import { supabase } from '@/integrations/supabase/client';

export const runContentBackfill = async () => {
  console.log('Starting content backfill...');
  console.log('Current user ID:', (await supabase.auth.getUser()).data.user?.id);
  
  try {
    // Get files from storage
    const { data: files, error: listError } = await supabase.storage
      .from('bulletin-images')
      .list('', { limit: 1000 });

    if (listError) {
      console.error('Error listing files:', listError);
      return { success: false, error: listError.message };
    }

    if (!files) {
      console.log('No files found');
      return { success: true, message: 'No files found' };
    }

    console.log(`Found ${files.length} files in bulletin-images bucket`);
    
    let backfilledCount = 0;
    let skippedCount = 0;
    const errors: string[] = [];

    // Process each file
    for (const file of files) {
      try {
        // Extract user ID from file path
        const pathParts = file.name.split('/');
        const fileUserId = pathParts[0];
        
        // Skip non-image files
        if (!file.name.match(/\.(jpg|jpeg|png|gif|webp|mp4|mov|avi)$/i)) {
          skippedCount++;
          continue;
        }

        // Get the public URL for this file
        const { data: { publicUrl } } = supabase.storage
          .from('bulletin-images')
          .getPublicUrl(file.name);

        // Check if this file is already referenced in bulletins
        const { data: existingBulletin } = await supabase
          .from('bulletins')
          .select('id')
          .or(`image_url.eq.${publicUrl},thumbnail_url.eq.${publicUrl}`)
          .limit(1);

        // Skip if file is already referenced
        if (existingBulletin && existingBulletin.length > 0) {
          skippedCount++;
          continue;
        }

        // Validate that the user exists
        const { data: userProfile } = await supabase
          .from('profiles')
          .select('id')
          .eq('id', fileUserId)
          .limit(1);

        if (!userProfile || userProfile.length === 0) {
          errors.push(`User ${fileUserId} not found for file ${file.name}`);
          continue;
        }

        // Determine if this is a video or image
        const isVideo = file.name.match(/\.(mp4|mov|avi)$/i);
        const fileType = isVideo ? 'video' : 'image';

        // Create bulletin record
        const bulletinData = {
          user_id: fileUserId,
          content: `Restored from storage: ${file.name.split('/').pop()}`,
          image_url: publicUrl,
          thumbnail_url: isVideo ? null : publicUrl,
          file_type: fileType,
          moderation_status: 'approved',
          is_relic: false,
          is_update: false,
          created_date: new Date().toISOString().split('T')[0],
          expires_at: null // Permanent posts
        };

        const { error: insertError } = await supabase
          .from('bulletins')
          .insert(bulletinData);

        if (insertError) {
          errors.push(`Failed to create bulletin for ${file.name}: ${insertError.message}`);
          continue;
        }

        backfilledCount++;
        console.log(`Created bulletin for file: ${file.name}`);

      } catch (error) {
        errors.push(`Error processing ${file.name}: ${error.message}`);
      }
    }

    console.log(`Backfill completed: ${backfilledCount} posts created, ${skippedCount} files skipped, ${errors.length} errors`);
    
    return { 
      success: true, 
      backfilledPosts: backfilledCount,
      skippedFiles: skippedCount,
      totalFiles: files.length,
      errors 
    };

  } catch (error) {
    console.error('Backfill error:', error);
    return { success: false, error: error.message };
  }
};